import { Modal, Button } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { api_url } from "../../constant/constant";
import { useNavigate } from "react-router-dom";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import AddLcUserModal from "../AddLcUserModal/AddLcUserModal";
import { showToast } from "../ShowToast/ToastNotification";
import { NavLink } from "react-router-dom";
// import './PoliceUser.css';

const CampaignUsers = ({ id }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  // State variables
  const [data, setLcUser] = useState([]);
  const [links, setLinks] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);

  const handleCheckboxChange = (e, id) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      // Add the id to selectedIds if it's checked
      setSelectedIds((prevSelectedIds) => [...prevSelectedIds, id]);
    } else {
      // Remove the id from selectedIds if it's unchecked
      setSelectedIds((prevSelectedIds) =>
        prevSelectedIds.filter((selectedId) => selectedId !== id)
      );
    }
  };
  // Handle navigation to Question page with lesson id
  const handleAnswersClick = (id) => {
    navigate(`/question/${id}`); // Pass lesson id as a route parameter
  };

  const handleRemove = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("userToken");

      const response = await fetch(
        `${api_url}/compliance-campaigns/unassign-users`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            campaign_id: id,

            user_ids: selectedIds,
          }),
        }
      );

      const result = await response.json();

      if (response.ok && result.status === "success") {
        showToast(t("CampaignUsersdeletesuccessfully"), "success");
        fetchUserModal("");
      } else {
        showToast(t("failedtodeleteCampaignUsers"), "error");
      }
    } catch (error) {
      console.error("Error while unassigning users:", error);
      showToast(t("somethingwentwrong"), "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (searchValue !== "") {
      const filteredData = data.filter(
        (item) =>
          item.email.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.username.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.firstname.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.lastname.toLowerCase().includes(searchValue.toLowerCase())
      );
      setLcUser(filteredData);
    } else {
      fetchUserModal("");
    }
  }, [searchValue]);

  // Fetch questions data with pagination
  const fetchUserModal = async (url) => {
    setLoading(true); // Start loading
    let page = 1;

    if (url) {
      const temp = url.split("?page=");
      page = temp[1] || 1;
    }

    try {
      const token = localStorage.getItem("userToken");
      const response = await fetch(
        `${api_url}/compliance-campaigns/${id}/users`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log("API Response:", result);

      // Set users and links even if data is empty
      setLcUser(result.data || []);
      setLinks(result.data?.links || []);
    } catch (error) {
      console.error("Error fetching data:", error);
      showToast(t("errorfetchingdata"), "error"); // Only show if actual fetch or JSON parse failed
    } finally {
      setLoading(false); // Always stop loading
    }
  };

  // Define table columns
  const columns = React.useMemo(
    () => [
      {
        accessorKey: "email",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <i className="bi bi-clipboard-data"></i>
            {t("Email")}
          </div>
        ),
        colName: t("Email"),
      },
      {
        accessorKey: "firstname",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <i className="bi bi-clipboard-data"></i>
            {t("FirstName")}
          </div>
        ),
        colName: t("FirstName"),
      },
      {
        accessorKey: "lastname",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <i className="bi bi-clipboard-data"></i>
            {t("LastName")}
          </div>
        ),
        colName: t("LastName"),
      },

      {
        accessorKey: "id", // Correct accessor key
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <img src="/images/fi_alert-octagon.png" alt="Source" />
            {t("Action")}
          </div>
        ),
        cell: ({ getValue }) => {
          const id = getValue(); // Extract the value of the 'id' column
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {/* Checkbox component */}
              <input
                type="checkbox"
                onChange={(e) => handleCheckboxChange(e, id)}
                // You can add a checked prop here if needed, e.g., checked={isChecked}
              />
            </div>
          );
        },
        colName: t("Action"), // Correct property spelling
      },
    ],
    []
  );

  // Create a table instance
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className="p-4 mb-4">
      <div>
        <div className="primaryBlueBox pad mb-4">
          <div className="row">
            <div className="col-md-4">
              <label className="form-label">{t("SearchUsers")}</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("Searchbyname")}
                  aria-label="Search by name"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                />
                <button
                  className="btn btn-outline-secondary btnSearchIcon"
                  type="button"
                >
                  <i className="bi bi-search"></i>
                </button>
              </div>
            </div>
            <div className="col-md-1">
              <div className="vrLine"></div>
            </div>
            <div className="col-md-7">
              <NavLink
                className="btnWhiteGradient mt-4"
                to={`/AddCampaignUsers/${id}/AddCampaignUsers`}
              >
                <i className="bi bi-envelope me-2 mt-3 h6"></i>{" "}
                {t("AddCampaignUsers")}
              </NavLink>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="d-flex justify-content-center align-items-center  mt-5">
            <div
              className="spinner-border loader-api"
              role="status"
              style={{
                borderTopColor: "#6897CB",
                borderBottomColor: "#6897CB",
                borderLeftColor: "#6897CB",
                marginTop: "50px",
              }}
            ></div>
          </div>
        ) : (
          <div className="bg-light px-3 py-3 userTableWrapper resTable">
            {window.innerWidth < 768 ? (
              <>
                {table.getRowModel().rows.map((row) => (
                  <div key={row.id} className="stacked-row">
                    {row.getVisibleCells().map((cell) => (
                      <div key={cell.id} className="stacked-cell">
                        {cell.column.columnDef.colName != "ID" ? (
                          <strong>{cell.column.columnDef.colName}: </strong>
                        ) : (
                          ""
                        )}

                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </div>
                    ))}
                  </div>
                ))}

                {data.length > 0 && (
                  <div className="button-container text-center mt-3">
                    <button
                      onClick={handleRemove}
                      className="btn btn-danger"
                      disabled={selectedIds.length === 0}
                    >
                      {t("RemoveSelected")}
                    </button>
                  </div>
                )}
              </>
            ) : (
              <div className="1">
                <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                  <table className="table table-bordered table-hover">
                    <thead className="thead-dark">
                      {table.getHeaderGroups().map((headerGroup) => (
                        <tr key={headerGroup.id}>
                          {headerGroup.headers.map((header) => (
                            <th key={header.id}>
                              {flexRender(
                                header.column.columnDef.header,
                                header.getContext()
                              )}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>

                    <tbody>
                      {table.getRowModel().rows.map((row) => (
                        <tr key={row.id}>
                          {row.getVisibleCells().map((cell) => (
                            <td key={cell.id}>
                              {flexRender(
                                cell.column.columnDef.cell,
                                cell.getContext()
                              )}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {data.length > 0 && (
                  <div className="button-container text-center mt-3">
                    <button
                      onClick={handleRemove}
                      className="btn btn-danger"
                      disabled={selectedIds.length === 0}
                    >
                      {t("RemoveSelected")}
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        <div className="navigationWrapper">
          <ul>
            {links.map((link, index) => (
              <li
                key={index}
                className={`${link.active ? " active " : ""} ${
                  link.url === null ? " disabled " : ""
                }`}
                onClick={
                  link.url !== null ? () => fetchUserModal(link.url) : undefined
                }
              >
                <div dangerouslySetInnerHTML={{ __html: link.label }} />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CampaignUsers;
